import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=a33c06f4&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=ts"
export * from "./Resources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c06f4",
  null
  
)

export default component.exports